import React, { Component } from 'react'
import { Row, Col, Input, Radio, DatePicker, Select } from 'hljd'
import { AllArea } from 'hlj-components'
import { toJS } from 'mobx'
import moment from 'moment'
import { SOURCE_LIST } from '../../constant'
import { getMerchantInfo } from '@util'
import _toString from 'lodash/toString'

const RadioGroup = Radio.Group
const Option = Select.Option

class BasicInfo extends Component {
  timer = null
  onBlur = e => {
    const value = e.target.value
    if (!value) {
      return
    }

    if (this.props.type === 'new') {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.props.store.searchPhone(value)
      }, 500)
      // this.props.store.searchPhone(value)
    }
  }

  /**
   * 先取详情中的，如果没有取商家信息中的
   */
  getInitialShopAreaIds = detailData => {
    const { shop_area_ids } = getMerchantInfo()

    return (
      detailData.shop_area_ids ||
      (shop_area_ids
        ? shop_area_ids.length === 3
          ? shop_area_ids.slice(0, 2)
          : shop_area_ids
        : [])
    )
  }

  render() {
    const {
      getFieldDecorator,
      detailData = {},
      initValue = {},
      type,
      store: { sourceList }
    } = this.props

    const _sourceList = type === 'new' ? SOURCE_LIST : toJS(sourceList)
    return (
      <div className="basic-info">
        <Row>
          <Col span={12} style={{ paddingRight: '10px' }}>
            <div>
              <span className="label require">姓名:</span>
              <div style={{ width: 240 }}>
                {getFieldDecorator('user_name', {
                  initialValue: detailData.user_name || ''
                })(
                  <Input
                    type="text"
                    style={{ width: '112px' }}
                    placeholder="请输入"
                  />
                )}
                {getFieldDecorator('gender', {
                  initialValue: detailData.gender + '' || '1'
                })(
                  <RadioGroup style={{ marginLeft: '12px' }}>
                    <Radio value={'1'}>先生</Radio>
                    <Radio value={'2'}>女士</Radio>
                  </RadioGroup>
                )}
              </div>
            </div>
            <div>
              <span className="label">手机号:</span>
              {getFieldDecorator('user_phone', {
                initialValue:
                  initValue.user_phone || detailData.user_phone || ''
              })(
                <Input
                  type="text"
                  style={{ width: 240 }}
                  onBlur={this.onBlur}
                  placeholder="请输入"
                />
              )}
            </div>
            <div>
              <span className="label">微信号:</span>
              {getFieldDecorator('user_wechat', {
                initialValue: detailData.user_wechat || ''
              })(
                <Input
                  type="text"
                  style={{ width: 240 }}
                  placeholder="请输入"
                />
              )}
            </div>
            <div>
              <span className="label">婚期:</span>
              {getFieldDecorator('weddingday', {
                initialValue: detailData.weddingday
                  ? moment(detailData.weddingday)
                  : undefined
              })(<DatePicker style={{ width: 240 }} />)}
            </div>
            <div>
              <span className="label">城市:</span>
              {getFieldDecorator('shop_area_id', {
                initialValue: this.getInitialShopAreaIds(detailData).map(item =>
                  _toString(item)
                )
              })(
                <AllArea
                  style={{ width: 240 }}
                  placeholder="请选择"
                  changeOnSelect
                />
              )}
            </div>
            <div>
              <span className="label">来源:</span>
              {getFieldDecorator('source', {
                initialValue: detailData.source
              })(
                <Select
                  style={{ width: 240 }}
                  placeholder="请选择"
                  disabled={type === 'edit'}
                >
                  {_sourceList.map(({ id, title }) => {
                    return (
                      <Option key={id} value={id}>
                        {title}
                      </Option>
                    )
                  })}
                </Select>
              )}
            </div>
          </Col>
          <Col span={12} className="right">
            <div>
              <span className="label">伴侣姓名:</span>
              {getFieldDecorator('mate_name', {
                initialValue: detailData.mate_name
              })(
                <Input
                  type="text"
                  style={{ width: '238px' }}
                  placeholder="请输入"
                />
              )}
            </div>
            <div>
              <span className="label">伴侣手机号:</span>
              {getFieldDecorator('mate_phone', {
                initialValue: detailData.mate_phone
              })(
                <Input
                  type="text"
                  style={{ width: '238px' }}
                  placeholder="请输入"
                />
              )}
            </div>
            <div>
              <span className="label">伴侣微信号:</span>
              {getFieldDecorator('mate_wechat', {
                initialValue: detailData.mate_wechat
              })(
                <Input
                  type="text"
                  style={{ width: '238px' }}
                  placeholder="请输入"
                />
              )}
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default BasicInfo
